import {
  // eslint-disable-next-line no-restricted-imports
  useAsyncFetch as originalUseAsyncFetch,
  UseAsyncFetchDependencies,
  UseAsyncFetchParams,
} from '@agro1desenvolvimento/react-hooks';
import { useEffect, useMemo } from 'react';
import Agro1Toast from '../components/Agro1Toast';
import Agro1Loader from '../components/Agro1Loader';

const useAsyncFetch = <T>(
  { withLoader, ...params }: Params<T>,
  dependencies: UseAsyncFetchDependencies,
) => {
  const { loading, ...asyncFetchParams } = originalUseAsyncFetch(
    {
      ...params,
      onErrorMessage: (message) => {
        Agro1Toast.show({
          detail: message,
          severity: 'error',
          sticky: true,
        });
      },
    },
    dependencies,
  );

  useEffect(() => {
    if (!withLoader || !loading) return;

    const loaderId = Agro1Loader.show();

    return () => {
      Agro1Loader.close(loaderId);
    };
  }, [withLoader, loading]);

  return useMemo(
    () => ({ loading, ...asyncFetchParams }),
    [loading, asyncFetchParams],
  );
};

type Params<T> = {
  withLoader?: boolean;
} & Omit<UseAsyncFetchParams<T>, 'onErrorMessage'>;

export default useAsyncFetch;
